import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "modal",
    "modalImage",
    "prevButton",
    "nextButton",
    "indicators",
  ];

  initialize() {
    this.currentIndex = 0;
    this.images = [];
  }

  open(event) {
    event.preventDefault();

    const gallerySection = event.currentTarget.closest("[data-gallery]");
    this.images = Array.from(
      gallerySection.querySelectorAll("[data-gallery-image]")
    ).map((img) => img.dataset.imageUrl);

    this.currentIndex = this.images.indexOf(
      event.currentTarget.dataset.imageUrl
    );

    this.showImage();

    this.modalTarget.classList.remove("hidden");
  }

  close() {
    this.modalTarget.classList.add("hidden");
  }

  next() {
    if (this.currentIndex < this.images.length - 1) {
      this.currentIndex++;
      this.showImage();
    }
  }

  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.showImage();
    }
  }

  goTo(event) {
    this.currentIndex = parseInt(event.currentTarget.dataset.index, 10);
    this.showImage();
  }

  showImage() {
    this.modalImageTarget.src = this.images[this.currentIndex];

    this.prevButtonTarget.classList.toggle("hidden", this.currentIndex === 0);
    this.nextButtonTarget.classList.toggle(
      "hidden",
      this.currentIndex === this.images.length - 1
    );

    this.indicatorsTarget.querySelectorAll("button").forEach((dot, index) => {
      dot.classList.toggle("bg-negative/60", index === this.currentIndex);
      dot.classList.toggle("bg-negative/10", index !== this.currentIndex);
    });
  }
}
